import type { ChatDocument } from '@/store';
import { ERROR_STATUS_VALUES } from '@/types/file';

export function orderChatDocumentsFailedFirst(documents: ChatDocument[] | null | undefined): ChatDocument[] {
  return [...(documents ?? [])].sort((a, b) => {
    const aFailed = ERROR_STATUS_VALUES.includes(a.status);
    const bFailed = ERROR_STATUS_VALUES.includes(b.status);
    if (aFailed === bFailed) return 0;
    return aFailed ? -1 : 1;
  });
}
